var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"scrollbar-watcher",staticClass:"scrollbar-watcher",class:{ debug: _vm.debug }})
}
var staticRenderFns = []

export { render, staticRenderFns }